import { createFileRoute } from '@tanstack/react-router';

import GoodbyePage from '@/pages/goodbye/GoodbyePage';

const goodbyeTitle = 'Rodeo has closed';
const goodbyeDescription =
  'Thank you for being part of Rodeo. We wish you all the best with what comes next.';

export const Route = createFileRoute('/')({
  component: GoodbyePage,
  head: () => ({
    meta: [
      { title: goodbyeTitle },
      { name: 'description', content: goodbyeDescription },
      { property: 'og:url', content: 'https://gorodeo.app' },
      { property: 'og:title', content: goodbyeTitle },
      { property: 'og:description', content: goodbyeDescription },
    ],
    links: [{ rel: 'canonical', href: 'https://gorodeo.app' }],
  }),
});
